import { Button } from "@ews-admin/global-design-system";
import React from "react";
import { Control, FieldErrors, UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Staff } from "../../../types/staff.definition";
import {
  NotificationPreferences,
  PersonalInfoSection,
  RoleSelector,
} from "./components";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StaffFormData = any;

interface SecretaryFormProps {
  control: Control<StaffFormData>;
  setValue: UseFormSetValue<StaffFormData>;
  errors: FieldErrors<StaffFormData>;
  editingStaff: Staff | null;
  isSubmitting: boolean;
  isSubmitDisabled: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  isDoctorLimitReached?: boolean;
  isSecretaryLimitReached?: boolean;
  onUpgradeLicence?: () => void;
}

export const SecretaryForm: React.FC<SecretaryFormProps> = ({
  control,
  setValue,
  errors,
  editingStaff,
  isSubmitting,
  isSubmitDisabled,
  onSubmit,
  onCancel,
  isDoctorLimitReached,
  isSecretaryLimitReached,
  onUpgradeLicence,
}) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      {/* Role Selection */}
      {!editingStaff && (
        <RoleSelector
          control={control}
          setValue={setValue}
          disabled={!!editingStaff}
          isDoctorLimitReached={isDoctorLimitReached}
          isSecretaryLimitReached={isSecretaryLimitReached}
          onUpgradeLicence={onUpgradeLicence}
        />
      )}

      {/* Personal Information */}
      <PersonalInfoSection
        control={control}
        setValue={setValue}
        errors={errors}
        emailDisabled={!!editingStaff}
        phoneDisabled={!!editingStaff}
        dateOfBirthRequired={!editingStaff}
      />


      {/* Notification Preferences */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <NotificationPreferences
          control={control}
          setValue={setValue}
          errors={errors}
        />
      </div>

      {/* Form Actions */}
      <div className="flex gap-3 justify-end pt-6 border-t border-neutral-200">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t("common.cancel")}
        </Button>
        <Button
          type="submit"
          loading={isSubmitting}
          disabled={isSubmitDisabled || isSubmitting}
        >
          {editingStaff
            ? t("staff.manage.form.updateStaff")
            : t("staff.manage.form.addStaff")}
        </Button>
      </div>
    </form>
  );
};
